import angular from "angular";

angular.module("folkeuni").component("cartProductOptions", {
  bindings: {
    options: "<",
    selectedOptions: "<",
    onClose: "&"
  },
  controller: function () {
    var $ctrl = this;
    $ctrl.selected = {};

    $ctrl.$onInit = function () {
      // Map selectedOptions (array af valgte items) til checkbox-model
      const selectedIds = ($ctrl.selectedOptions || []).map(function(opt) { return opt.id; });
      ($ctrl.options || []).forEach(function(option) {
        $ctrl.selected[option.id] = {};
        (option.items || []).forEach(function(item) {
          $ctrl.selected[option.id][item.id] = selectedIds.includes(item.id);
        });
      });
    };

    $ctrl.selectOption = function(optionId, itemId) {
      $ctrl.selected[optionId][itemId] = !$ctrl.selected[optionId][itemId];
    };

    $ctrl.isSelected = function(optionId, itemId) {
      return !!$ctrl.selected[optionId][item.id];
    };

    $ctrl.handleClose = function() {
      if ($ctrl.onClose) $ctrl.onClose({ selected: $ctrl.selected });
    };
  },
  templateUrl: "/shop-dist/templates/cart-product-options.html"
});
